<template>
    <div>
        <Header></Header>
        <div class="container">
            <div class="row mt-3 headerPanel bg-deal">
                <div class="col-sm-12">
                    <div class="row justify-content-between pt-4 px-3">
                        <div class="d-flex row align-items-unset">
                        <div class="w-auto row px-3 ml-3 position-relative d-flex dealTitleInput mb-2 mb-md-0" :class="{'opened':isHiddenTitle==true}">
                            <input type="text" class="row" :disabled="isHiddenTitle!=true" v-model="deal.title" v-on:keyup.13="updateTitle(deal.title)">
                            <div class="d-flex row align-items-center w-auto">
                                <i @click="isHiddenTitle=true" v-if="isHiddenTitle!=true" class="align-items-center px-1 pr-2 fas fa-pencil-alt cursor-pointer editTitle" style="color:#606f8c"></i>
                                <i @click="updateTitle(deal.title)" v-if="isHiddenTitle==true" class="d-flex align-items-center px-1 h-100 bg-success text-white fa fa-check cursor-pointer"></i>
                                <i @click="isHiddenTitle=undefined" v-if="isHiddenTitle==true"  class="d-flex align-items-center px-1 h-100 bg-danger text-white fa fa-close cursor-pointer"></i>
                            </div>                            
                        </div> 
                        <div class="ml-3 mb-2 mb-lg-0 w-auto py-1 mr-sm-2 d-flex align-items-center px-3 border-radius-4 bg-new-gray">
                            <div v-if="deal.closedDate!=undefined" class="d-flex">
                                <span class="f-12 float-left fas fa-calendar-check mr-2 crm-icon-color"></span>
                                <label class="cursor-pointer f-12 m-0" v-if="deal.closedDate!==undefined">{{formatDate(deal.closedDate.$date, "Do MMMM YYYY")}}</label>
                            </div>
                            <div v-else class="d-flex">
                                <span class="f-12 float-left f-11 float-left fas fa-calendar-check mr-2 crm-icon-color"></span>
                                <label class="f-12 m-0 light-gray-color cursor-pointer" v-show="expectedDateShow===false" v-if="deal.expectedDate!==undefined" @click="expectedDateShow=true">{{formatDate(deal.expectedDate.$date, "Do MMMM YYYY")}}</label>
                                <label class="f-11 cursor-pointer m-0" v-show="expectedDateShow===false" v-else @click="expectedDateShow=true">{{$ml.get('SET_AN_ESTIMATED')}}!</label>
                            </div>
                            <div v-show="expectedDateShow" class="dealDate">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="float-left new-ctk-deal w-75" v-if="deal.expectedDate!==undefined" label="" v-model="deal.expectedDate.$date" formatted="ll" @input="expectedDateChange"  :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="float-left new-ctk-deal w-75" v-else label="" v-model="expectedDate" formatted="ll" @input="expectedDateChange"  :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                <!-- <i class="icon-line-iptal iptal float-left f-10" @click="expectedDateShow=false"></i> -->
                                <!-- <i class="fa fa-times-circle font-m " @click="expectedDateShow=false" style="padding-top:11px;padding-left:4px;"></i> -->
                                <i class="fa fa-close Iconbtn float-left px-2 ml-2 cursor-pointer font-sm" @click="expectedDateShow=false"></i>
                                
                            </div>
                        </div> 
                        </div>
                        <div class="d-flex statuBtnGroup">
                            <div class="float-left mr-2">
                                <button type="button" class="btn-outline-success cursor-pointer statuBtn" @click="dealWon" v-if='deal.status!==2 && deal.status!==3'>{{$ml.get('WON')}}</button>
                                <button type="button" class="btn-success cursor-pointer statuBtn" @click="dealOpenAgain" v-if="deal.status===2&&$can('can_reopen_closed_deals')">{{$ml.get('REOPEN')}}</button>
                                <span class="badge badge-success p-2" v-else-if="deal.status===2">{{$ml.get('WON')}}</span>
                                <div class="text-center" v-if='deal.status===3'>
                                    <span class="w-100 f-11 float-left color-gray">{{$ml.get('NOTE')}}:</span>
                                    <p class="f-11 m-0">{{deal.lostReason}}</p>
                                </div>
                            </div>
                            <div class="float-left">
                                <button type="button" class="btn-outline-danger cursor-pointer statuBtn" data-toggle="modal" data-target="#dealLoseModal" v-if='deal.status!==2 && deal.status!==3'>{{$ml.get('NOT_WON')}}</button>
                                <button type="button" class="btn-outline-danger cursor-pointer statuBtn" @click="dealOpenAgain" v-if="deal.status===3&&$can('can_reopen_closed_deals')">{{$ml.get('REOPEN')}}</button>
                                <span class="badge badge-danger p-2" v-else-if="deal.status===3">{{$ml.get('LOST')}}</span>
                                <div class="modal fade" id="dealLoseModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title f-w-normal font-family-bold" id="exampleModalLongTitle">{{$ml.get('REASONS_FOR_LOSS')}}</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="dealLosePopup border-radius-20 light-blue-border dealBtnStyle">
                                                    <select v-model="dealLoseSelect" class="form-control w-auto h-auto input-padding f-w-normal font-family-bold ml-2 mr-2 f-11 border-radius-20 light-blue-border">
                                                        <option value="0">{{$ml.get('COMPETITOR_PREFERRED')}}</option>
                                                        <option value="1">{{$ml.get('PRICE_ORIENTED_LOSS')}}</option>
                                                        <option value="2">{{$ml.get('NO_PRODUCT_NEEDED')}}</option>
                                                        <option value="3">{{$ml.get('OTHER')}}</option>
                                                    </select>
                                                    <textarea v-model="dealLoseInput" type="text" class="m-2 pl-2 light-blue-bg-40 light-blue-border-40 w-75 border-radius-20 f-w-normal f-11 font-family-bold" rows="3" :placeholder="$ml.get('WRITE_DESCRIPTION')"></textarea>
                                                    <div class="pr-3">
                                                        <button class="float-right btn btn-lg" style="height:unset" @click="dealLose">{{$ml.get('SAVE')}}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                             
                        </div>
                    </div>
                    <div class="row pt-2 px-3">
                        <div class="col-12">
                            <div class="row justify-content-between infoDeal">
                                <div class="d-flex col-md-7 col-lg-9 flex-wrap px-0">
                                    <div class="d-flex w-auto mr-sm-2 mb-2 mb-lg-0 border-radius-4  overflow-hidden">
                                        <div class="px-3 f-13 p-1 cursor-pointer d-flex align-items-center crm-detail-bg mr-2 border-radius-4" style="height:28px;" v-show="isHiddenContact">
                                            <i class="far fa-building mr-2 crm-icon-color" ></i>
                                            <span v-if="organization!==undefined && organization.name" @click="organizationCard(organization._id.$oid)" :title="organization.name">{{filterName(organization.name)}}</span>
                                            <label v-else class="font-family-bold f-w-normal mb-0">{{$ml.get('COMPANY_NOT_FOUND')}}!</label>
                                        </div>
                                        <div class="p-1 px-2 crm-detail-bg cursor-pointer  f-12 d-flex align-items-center border-radius-4" v-show="isHiddenContact">
                                            <i class="far fa-address-card mr-2 crm-icon-color" style="padding-top:2px;"></i>
                                            <span v-if="contact.n !== undefined"  @click="contactCard(contact._id.$oid)" >{{contact.n}} {{contact.sn}}</span>
                                            <label v-else v-show="isHiddenContactSelect===false"  @dblclick="isHiddenContactSelect=true,quickContact()" class="f-13 m-0">{{$ml.get('NOT_FOUND_PERSON')}}!</label>
                                           
                                        </div>
                                    </div>
                                    <div class="d-flex w-auto mr-sm-2 mb-2 mb-lg-0 border-radius-4 overflow-hidden">
                                        <div class="crm-detail-bg p-1 px-3  cursor-pointer d-flex align-items-center">
                                            <span class="f-13" @click="editRelationship('product')" data-toggle="modal" data-target="#relationship"> {{deal.productList!==undefined?$ml.get('PRODUCTS'):$ml.get('ADD_PRODUCT')}}</span>
                                        </div>
                                        
                                        <div v-show="!isHiddenValue" class=" p-1 px-2 crm-detail-bg cursor-pointer d-flex align-items-center">
                                            <span>{{currencySymbol(deal.currency)}} {{toFix(deal.value)}}</span>
                                        </div>
                                        <div v-show="!isHiddenValue" @click="isHiddenValue=true" class="crm-detail-bg p-1 pr-2 pl-1 cursor-pointer crm-icon-color d-flex align-items-center">
                                            <i class="fa fa-pencil" style="padding-bottom:2px;"></i>
                                        </div>
                                        <div class="valueEditCurrency">
                                            <select v-show="isHiddenValue" v-model="deal.currency" @change="changeCurrency($event)" class="new-select bg-white pr-4">
                                                <option v-for="(cur,index) in currencyData()" v-bind:key="index" :value="cur.id">{{cur.label}}</option>
                                            </select>
                                        </div>
                                        <div class="valueEditInput" v-show="isHiddenValue">
                                            <input type="number" onwheel="this.blur()" v-on:keyup.13="updateValue" style="width: 50px;" v-model="parseToFix"/>
                                        </div>
                                        <div class="valueEditBtn bg-new-light d-flex align-items-center" v-show="isHiddenValue">
                                            <i class="fa fa-check color-green float-left px-2 cursor-pointer" v-show="isHiddenValue" @click="updateValue()"></i>
                                            <i class="fa fa-close color-red float-left px-2 cursor-pointer" v-show="isHiddenValue" @click="isHiddenValue=false"></i>
                                        </div>
                                    </div>
                                    
                                    <div class="w-auto" v-show="isHiddenContactSelect">
                                        <select class="form-control border-radius-20 light-blue-border h-28 f-14 input-padding float-left w-auto" @blur="isHiddenContactSelect=false,isHiddenContact=true" :required="true" @change="selectContact($event)">
                                            <option>{{$ml.get('SELECT')}}...</option>
                                            <option v-for="i in items" :id="i._id.$oid" :value="i._id.$oid">{{i.n}} {{i.sn}}</option>
                                        </select>
                                        <i class="icon-line-iptal iptal float-left p-1" @click="isHiddenContactSelect=false,isHiddenContact=true"></i>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center col-md-5 col-lg-3 justify-content-md-end px-0">
                                    <div class="bg-new-light pr-0 pl-1 border border-radius-4 w-100 d-flex align-items-center" >
                                        <span class="holderTitle py-1 pl-2">{{$ml.get('HOLDER')}} </span>
                                        <span v-if="$can('can_change_owner_of_items')" class="border-left px-2 d-flex align-items-center bg-white p-1 cursor-pointer hover-bg-primary" data-toggle="dropdown" id="userList" aria-haspopup="true" style="height:28px; border-radius: 0px 4px 4px 0px;" aria-expanded="false">{{ownerName}} {{ownerSurName}}<i class="fa fa-angle-down f-16 ml-1"></i></span>
                                        <span v-else class="bg-new-gray px-2 d-flex align-items-center p-1" id="userList" aria-haspopup="true" aria-expanded="false" style="height:28px;border-radius: 0px 4px 4px 0px;">{{ownerName}} {{ownerSurName}}</span>
                                        
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="userList">
                                            
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li v-if="usersForFilter.length==0">{{$ml.get('NO_USER_FOUND')}}</li>
                                                <li class="p-0" v-for="u in usersForFilter">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filter" :checked="u['_id']['$oid']==deal.cuid.$oid" @change="changeHolder($event)" :value="u['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{u.name}} {{u.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
        
                                    </div>             
                                    <div class="crm-detail-icon-btn ml-2 d-flex justify-content-center align-items-center px-2">
                                        <i v-if="((isOwner&&$can('can_delete_deals'))||(!isOwner&&$can('can_delete_other_users_deals')))" data-toggle="modal" data-target="#deleteDeal" class="fas fa-trash f-16 light-darkGray-color hover-bg-primary p-1 cursor-pointer" id="dealSettings" ></i>
                                        <!-- <div class="p-0 new-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="dealSettings">
                                            <p v-if="((isOwner&&$can('can_delete_deals'))||(!isOwner&&$can('can_delete_other_users_deals')))"  class="dropdown-item m-0 py-2 btn-click"  data-toggle="modal" data-target="#deleteDeal">{{$ml.get('DELETE_OPPORTUNITIES')}}</p>
                                        </div> -->
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 dealStatus mt-3">
                    <div class="stageSelect row" v-if="windowWidth<maxMobilSize">
                        <div class="w-100 selectedStage text-white" @click="toggleClick('stageToggle')"
                        :class="{'bg-new-blue text-white':deal.stageId>=1}">{{selectedStage}}<i class="fa fa-angle-down d-md-none"></i></div>
                        <div class="w-100" :style="windowWidth<maxMobilSize ? {display:'none'}:{}" id="stageToggle">
                            <div class="cursor-pointer bg-new-gray" :class="{'active bg-new-blue text-white':deal.stageId>=1}" @click="stageUpdate(1),selectedStage=$ml.get('STEP_1')">
                                <span>{{$ml.get('STEP_1')}}</span>
                            </div>
                            <div class="cursor-pointer bg-new-gray" :class="{'active bg-new-primary text-white':deal.stageId>=2}" @click="stageUpdate(2),selectedStage=$ml.get('STEP_2')">
                                <span>{{$ml.get('STEP_2')}}</span>
                            </div>
                            <div class="cursor-pointer bg-new-gray" :class="{'active bg-new-secondry text-white':deal.stageId>=3}" @click="stageUpdate(3),selectedStage=$ml.get('STEP_3')">
                                <span>{{$ml.get('STEP_3')}}</span>
                            </div>
                            <div class="cursor-pointer bg-new-gray" :class="{'active bg-new-darkSecondry text-white':deal.stageId>=4}" @click="stageUpdate(4),selectedStage=$ml.get('STEP_4')">
                                <span>{{$ml.get('STEP_4')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row f-12" v-else>
                        <div class="col-3 justify-content-between d-flex align-items-center cursor-pointer bgDealTab" :class="{'active bg-new-blue text-white':deal.stageId>=1}" @click="stageUpdate(1)">
                            <span>{{$ml.get('STEP_1')}}</span>
                        </div>
                        <div class="col-3 justify-content-between d-flex align-items-center cursor-pointer bgDealTab" :class="{'active bg-new-primary text-white':deal.stageId>=2}" @click="stageUpdate(2)">
                            <span>{{$ml.get('STEP_2')}}</span>
                        </div>
                        <div class="col-3 justify-content-between d-flex align-items-center cursor-pointer bgDealTab" :class="{'active bg-new-secondry text-white':deal.stageId>=3}" @click="stageUpdate(3)">
                            <span>{{$ml.get('STEP_3')}}</span>
                        </div>
                        <div class="col-3 justify-content-between d-flex align-items-center cursor-pointer bgDealTab" :class="{'active bg-new-darkSecondry text-white':deal.stageId>=4}" @click="stageUpdate(4)">
                            <span>{{$ml.get('STEP_4')}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="row mr-md-0">
                        <div class="col-12 px-0 border border-radius-4 mcBgDarkGrey mb-3">
                            <div class="border-radius-4 hpx-50 d-flex align-items-center justify-content-between col-12 crm-modal-header" @click="toggleClick('dealDetailToggle')" style="border-bottom:1px solid #dcdddd">
                                <label class="m-0 align-self-center f-14 f-w-normal">{{$ml.get('DETAIL_DEAL')}} </label>
                                 <i class="fas fa-chevron-down"></i>
                            </div>
                            <div class="p-3 bg-white" :style="windowWidth<maxMobilSize ? {display:'none'}:{}" id="dealDetailToggle">
                                <div class="d-flex">
                                    <label class="new-label mb-0 col-4 pl-0">{{$ml.get('POSSIBILITY')}}</label>
                                    <div class="inputInfo col-8 pr-0">
                                        <input type="text" v-model="getPossibility" disabled class="new-input input-readonly">
                                        <span class="bg-gray position-absolute">%</span>
                                    </div>
                                </div>
                                <div class="d-flex mt-3">
                                    <label class="new-label mb-0 col-4 pl-0">{{$ml.get('DEGREE')}}</label>
                                    <div class="col-8 pr-0">
                                        <div class="wrapSelect bg-white rateIcon">
                                            <v-select :options="rateTitle" :reduce="label => label.value" label="label" @input="changeRate" v-model="deal['rate']" :searchable="false"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex mt-3">
                                    <label class="new-label mb-0 col-4 pl-0">{{$ml.get('SOURCE')}}</label>
                                    <div class="col-8 pr-0">
                                        <div class="wrapSelect bg-white">
                                            <v-select :options="soruceTitle" :reduce="label => label.value" label="label" @input="changeSource" v-model="deal['source']" :searchable="false"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 px-0 border border-radius-4 mcBgDarkGrey mb-3">
                            <ul class="d-flex crm-modal-header nav dealCenterUl hpx-50 justify-content-center">
                                <li class="w-auto text-center detailBorder"> 
                                    <a class="f-12" id="companyDetailTab" href="#companyDetail" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true" @click="upToggle('contactDetailToggle'),toggleClick('companyDetailToggle')">{{$ml.get('DETAILS_COMPANY')}}
                                        <i class="fas fa-chevron-down ml-3"></i>
                                    </a> 
                                </li>  
                                <li class="w-auto text-center"> 
                                    <a href="#personDetail" class="f-12" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true" @click="upToggle('companyDetailToggle'),toggleClick('contactDetailToggle')">{{$ml.get('PERSON_DETAILS')}}
                                        <i class="fas fa-chevron-down ml-3"></i>
                                    </a> 
                                </li>
                            </ul>
                            <div class="row tab-content w-100 bg-white mx-0">
                                <div class="col-12 tab-pane active px-0"  id="companyDetail">
                                    <organizationDetailPanel :data="this.organization" :permission="permission" field="dealCard" :user="user" />
                                </div>
                                <div class="col-12 tab-pane px-0" id="personDetail">
                                    <contactDetailPanel :type="dataType" :permission="permission" :user="user" @getData="deal.contactId=$event" field="dealCard" :data="this.deal.contactId"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-9 dealCenter">
                    <div class="row border border-radius-4 mcBgDarkGrey">
                    
                        <ul class="row crm-modal-header nav dealCenterUl hpx-50 px-3 mincrm-dynamic-tabs mx-0 w-100 border-radius-4" style="border-bottom:1px solid #dcdddd"> 
                            <li class="w-auto text-center bg-crm-tab" @click="getDealsLog()"> 
                                <a class="active" href="#organizationAll" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SUMMARY')}}</a> 
                            </li>
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#activitiesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('ACTIVITIES')}}</a> 
                            </li>
                            <li class="w-auto text-center crm-detail-tab dNoneMobil"> 
                                <a href="#processesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('PROCESSES')}}</a> 
                            </li>
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#remindersDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('REMINDERS')}}</a> 
                            </li> 
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#showNotePanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('NOTES')}}</a> 
                            </li>   
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#showMailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('EMAIL')}}</a> 
                            </li>   
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#specialArea" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SPECIAL_AREA')}}</a> 
                            </li>
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#bidDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('OFFER')}}</a> 
                            </li>   
                            <li class="w-auto text-center crm-detail-tab"> 
                                <a href="#file" @click="watchUpdated=watchUpdated+1"  data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('FILE')}}</a> 
                            </li>                                                                                              
                        </ul>
                        <div class="col-12 bg-white">
                        
                            <div class="row tab-content dealRowTabContent">
                                <div class="col-12 tab-pane active"  id="organizationAll">
                                    <completeShowPanel field="info" :deal="deal" :users="users" />
                                </div>
                                <div class="col-12 tab-pane"  id="activitiesDetailPanel">
                                    <activitiesDetailPanel field='deal' @updateActivity="updateActivity($event)" :users="users" @refleshData="getDeal()" :data="activities"/>
                                </div>
                                <div class="col-12 tab-pane"  id="processesDetailPanel">
                                    <processesDetailPanel field='deal' :users="users" :dataId="dealId"/>
                                </div>
                                <div class="col-12 tab-pane pb-5"  id="remindersDetailPanel">
                                    <div>
                                        <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" @successUpsert="getRemindersF()" :dealId="dealId"/>
                                    </div>
                                </div>
                                <div class="col-12 tab-pane"  id="showNotePanel"> 
                                    <div class="row">
                                        <div class="col-md-8 m-auto pt-3">
                                            <addNotePanel @updateDealNote="note.push($event),getDeal()" :data="deal" postField="deal" />
                                            <showNotePanel field="dealCard" :data="note" :users="users" :deal="deal" @refleshData="getDeal()"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 tab-pane"  id="showMailPanel">
                                    <div class="row">
                                        <div class="col-10 m-auto">
                                            <showMailPanel :dealId="dealId" :users="this.users" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 tab-pane"  id="specialArea">
                                    <special-area type="profil" postField="deal" @updateData="updateControl=$event" :users="users" :user="user" :data="deal" :customField="customFields"></special-area>
                                </div>
                                <div class="col-12 tab-pane"  id="bidDetailPanel">
                                    <bid-detail-panel :dealId="dealId" :deal="deal"></bid-detail-panel>
                                </div>
                                <div class="col-12 tab-pane pt-3"  id="file">
                                    <file :customerFiles="customerFiles" 
                                          :watchUpdated="watchUpdated"
                                          :dataDeal="deal"
                                          :showButton="true"
                                          @showCustomerFile="showCustomerFile($event)"
                                          @addNewFile="addNewFile($event)"
                                          @deleteFile="function($event){ 
                                            for(k in this.customerFiles){
                                            if(this.customerFiles[k]['oid']==$event['oid']){
                                                this.customerFiles.splice(k,1)
                                                 }
                                            }}"
                                    ></file>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- add Acitivty -->
            <div class="modal fade" id="addActivity" ref="newActivity" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                        <newActivity :methods='type' :permission="permission" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" :user="user" @refleshData="getDeal()" :users="users" :data="deal"/>
                    </div>
                </div>
            </div>
            <!-- Delete Deal -->
            <div class="modal fade" id="deleteDeal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-family-bold f-18 f-w-normal" id="exampleModalLongTitle">{{$ml.get('DELETE_EMAIL')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body font-family-bold f-14 f-w-normal">
                        {{$ml.get('ARE_YOU_SURE_WANT_TO_DELETE_DEAL')}}
                    </div>
                    <div class="modal-footer dealBtnStyle">
                        <button type="button" class="btn btn-secondary font-family-bold f-14 f-w-normal h-32" data-dismiss="modal">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-primary font-family-bold f-14 f-w-normal h-32"  @click="removeDeal(deal._id.$oid)">{{$ml.get('YES')}}!</button>
                    </div>
                    </div>
                </div>
            </div>
            <!-- Relationship Modal -->
            <div class="modal fade" id="relationship" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <relationship @updateData="relationShipData($event)" :permission="permission" @updateProduct="getDeal()" :data="deal" />
                        </div>
                    </div>
                </div>
            </div>
            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import Header from './header'
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'
import _ from 'underscore'
Vue.use(SlimDialog)
import specialArea from '@/components/customField'
import organizationDetailPanel from '@/components/organizationDetailPanel'
import newActivity from '@/components/newActivity'
import showNotePanel from '@/components/showNotePanel'
import showMailPanel from '@/components/showMailPanel'
import addNotePanel from '@/components/addNotePanel'
import contactDetailPanel from '@/components/contactDetailPanel'
import activitiesDetailPanel from '@/components/activitiesDetailPanel'
import processesDetailPanel from '@/components/processesDetailPanel'
import completeShowPanel from '@/components/completeShowPanel'
import bidDetailPanel from '@/components/bidDetailPanel'
import { VueEditor, Quill } from 'vue2-editor'
import relationship from '@/components/relationship.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
import reminderPanel from '@/components/reminderPanel'
import BidDetailPanel from './bidDetailPanel.vue'
import File from './file.vue'
export default {
    name: 'dealCard',
    components: {
        Header,
        VueEditor,
        'special-area':specialArea,
        'organizationDetailPanel':organizationDetailPanel,
        'showNotePanel':showNotePanel,
        'addNotePanel':addNotePanel,
        'newActivity':newActivity,
        'contactDetailPanel':contactDetailPanel,
        "relationship":relationship,
        'activitiesDetailPanel':activitiesDetailPanel,
        'processesDetailPanel':processesDetailPanel,
        'completeShowPanel':completeShowPanel,
        'showMailPanel':showMailPanel,
        'reminderPanel':reminderPanel,
        'bidDetailPanel':bidDetailPanel,
        BidDetailPanel,
        File
    },
    data () {
    return {
        content: '',
        customToolbar:[
            [{ 'font': [] },'bold', 'italic', 'underline', 'strike'],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['link','clean'],
        ],
        deal:[],
        activities:[],
        contact:[],
        organization:[],
        organizationId:"",
        contactId:"",
        addPhoneText:"",
        addEmailText:"",
        isHiddenContact:true,
        isHiddenContactSelect:false,
        contactPhoneNumber:[],
        organizationPhoneNumber:[],
        users:[],
        items:[],
        customFields:[],
        user:[],
        stateId:"",
        search:"",
        isHiddenTitle:false,
        isHiddenValue:false,
        isHiddenAddr:false,
        isHiddenPhone:false,
        isHiddenEmail:false,
        isHiddenFax:false,
        isHiddenContactPhone:false,
        isHiddenContactEmail:false,
        isHiddenContactAddr:false,
        updateContactAddrText:"",
        updateContactPhoneText:"",
        updateContactEmailText:"",
        dealLoseSelect:0,
        dealLoseInput:"",
        selected: undefined,
        type:"save",
        dataType:"deal",
        expectedDateShow:false,
        expectedDate:"",
        note:[],
        organizationNote:[],
        contactNote:[],
        relationshipField:"",
        currency:"",
        customFieldType:"profil",
        permission:false,
        isDealOpen:true,
        ownerSurName:"",
        ownerName:"",
        updateControl:false,
        rateTitle:[
            {value: 0, label: this.$ml.get('SELECT')},
            {value: 1, label: this.$ml.get('NORMAL')},
            {value: 2, label: this.$ml.get('PRIORITY')},
            {value: 3, label: this.$ml.get('URGENT')},
        ],
        soruceTitle: [
            {value: '0', label: this.$ml.get('SELECT')},
            {value: this.$ml.get('ADVERTISING'), label:  this.$ml.get('ADVERTISING')},
            {value: this.$ml.get('PHONE_CALL'), label: this.$ml.get('PHONE_CALL')},
            {value: this.$ml.get('EMPLOYEE_ORUENTATION'), label: this.$ml.get('EMPLOYEE_ORUENTATION')},
            {value: this.$ml.get('EXTERNAL_ORUENTATION'), label: this.$ml.get('EXTERNAL_ORUENTATION')},
            {value: this.$ml.get('ONLINE_STORE'), label: this.$ml.get('ONLINE_STORE')},
            {value: this.$ml.get('BUSINES_PARTNER'), label: this.$ml.get('BUSINES_PARTNER')},
            {value: this.$ml.get('PUBLIC_RELATIONS'), label: this.$ml.get('PUBLIC_RELATIONS')},
            {value: this.$ml.get('SEMINAR'), label: this.$ml.get('SEMINAR')},
            {value: this.$ml.get('FAIR'), label: this.$ml.get('FAIR')},
            {value: 'Web', label: "Web"},
            {value: this.$ml.get('EMAILING'), label: this.$ml.get('EMAILING')},
            {value: this.$ml.get('SOCIAL_MEDIA'), label: this.$ml.get('SOCIAL_MEDIA')},
            {value: this.$ml.get('AFFILIATE_PROGRAMS'), label: this.$ml.get('AFFILIATE_PROGRAMS')},
            {value: this.$ml.get('SEO'), label: this.$ml.get('SEO')},
            {value: this.$ml.get('PAID_SEARCH'), label: this.$ml.get('PAID_SEARCH')},
            {value: this.$ml.get('ONLINE_ADVERTISING'), label: this.$ml.get('ONLINE_ADVERTISING')}
        ],
        clearModal:false,
        userSearch:"",
        reminders:[],
        selectedStage:this.$ml.get('STEP_1'),
        customerFiles:[],
        watchUpdated:0
    }
},
computed: {
    /*
    parseToFix() {
        if(this.deal.value!=undefined && this.deal.value!=0){
            return this.deal.value.toFixed(3);
        }
    },*/
    parseToFix: {
        get(){
            if(this.deal.value!=undefined){
                return this.deal.value.toFixed(2);
            }
        },
        set(val){
            this.deal.value=val
        } 
    },
    usersForFilter(){
        // function to compare names
        function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
        }
        
        return this.users.filter(user => {
            return user.name.toLowerCase().includes(this.userSearch.toLowerCase()) || user.surName.toLowerCase().includes(this.userSearch.toLowerCase())
        }).sort(compare)
    },
    isOwner(){
        if(this.deal.cuid){
            return this.ownerId==this.deal.cuid.$oid
        }
    },     
    listenState() {
        return this.$store.state.editLine;
    },
    listenStateStatus() {
        return this.$store.state.editLineStatu;
    },
    getPossibility(){
        switch(this.deal.stageId){
            case 1:
            this.selectedStage=this.$ml.get('STEP_1');
            return "20"
            break
            case 2:
            this.selectedStage=this.$ml.get('STEP_2');
            return "40"
            break
            case 3:
            this.selectedStage=this.$ml.get('STEP_3');
            return "60"
            break
            case 4:
            this.selectedStage=this.$ml.get('STEP_4');
            return "80"
            break
            default:
            return "20%"
        }
    },
    ...mapState(['baseUrl','editLineStatu','windowWidth','maxMobilSize','maxTabletSize']),
    ...mapGetters(['localeLang','ownerId'])
},
methods:{
    formatDate(value, format) {
        return this.$moment(value).format(format);
    },
    toFix(val) {
        if (val !== undefined && val !== null) {
            return Number(val).toFixed(2);
        }
        return '';
    },
    filterName(value) {
        if (!value) return '';
        if (value.length > 30) {
            return value.substring(0, 30) + '...';
        }
        return value;
    },
    getRemindersF(){
        var form = {}
        form.dealId = this.dealId
        this.getReminders(form).then((res)=>{return res}).then((res)=>{
            console.log("getReminders res")
            console.log(res)
            if(res.status.code=='0'){
                var remindersMutation = res.content.reminders.filter(r => {
                    return r.isActive==true&&r.date!==null
                })
                remindersMutation.forEach(r => {
                    if(r.day==undefined && r.date.$date!==undefined){
                        r.day = this.$moment(r.date.$date).format('YYYY-MM-DD')
                    }
                    if(r.time==undefined && r.date.$date!==undefined){
                        r.time = this.$moment(r.date.$date).format('HH:mm')
                    }
                })
                this.reminders = remindersMutation
            }
        })
    },
    updateRemindersData(newReminders){
        this.reminders = newReminders
    },
    changeHolder(event){
       
        let obj={
            cuid:{$oid:event.target.value}
        }
        this.dealUpdate(obj)
          setTimeout(() => {
          this.$root.$refs.completeShowPanel.getEventLogsF() 
       },100);
    },
    changeCurrency(event){
        if(this.deal.productList!=undefined){
            this.deal.value=0
        }
        for(var product in this.deal.productList){
            let obj ={}
            let dataObje={}
            var returnPrice = this.deal.productList[product].productId.prices.filter(function(price) {
                return price.currency == event.target.value;
            });
            if(returnPrice[0]!=undefined){
                obj["itemPrice"]=returnPrice[0].price
            }else{
                obj["itemPrice"]=0
            }
            this.deal.value+=obj["itemPrice"]
            
            obj["quantity"]=this.deal.productList[product].quantity
            obj["discountPercentage"]=this.deal.productList[product].discountPercentage
            
            dataObje['dealProductId']=this.deal.productList[product]._id.$oid
            dataObje['dealProductUpdateObj']=obj
            this.updateDealProduct(dataObje)
        }
        this.updateValue()
    },
    updateDealProduct(dataObje){
         
        axios({
            method:'POST',
            url:"/updateDealProduct",
            baseURL: this.baseUrl,
            data:dataObje,
            withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status.code==0){
                this.getDeal()
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    getDeal(){
         
        axios({
            method:'POST',
            url:'/getDeal',
            baseURL: this.baseUrl,
            data: {
                dealId:this.dealId,
            },
            withCredentials:true
        }).then((res)=>{
          return res
        }).then((res)=>{
            if(res.data.status===false){
            this.$router.push('/logout')
            }
            if(res.data.status.code==0){
                this.deal=res.data.content.deal
                if(!this.isOwner&&!this.$can('can_see_other_users_deals')){
                    this.$router.push('/deals')
                }
                if(res.data.content.deal.contactId!==undefined){
                    this.contact=res.data.content.deal.contactId
                    this.contactId=res.data.content.deal.contactId._id.$oid
                    
                    if(res.data.content.deal.contactId.notes!==undefined){
                        this.contactNote=res.data.content.deal.contactId.notes
                    }else{
                        this.contactNote=[]
                    }
                }
                if(res.data.content.deal.status!=1){
                    this.isDealOpen=false
                }else{
                    this.isDealOpen=true
                }
                if(res.data.content.deal.orgId!==undefined){
                    this.organization=res.data.content.deal.orgId
                    this.organizationId=res.data.content.deal.orgId._id.$oid
                    if(res.data.content.deal.orgId.notes!==undefined){
                        this.organizationNote=res.data.content.deal.orgId.notes
                    }else{
                        this.organizationNote=[]
                    }
                }
            
                if(res.data.content.deal.activityList!==undefined){
                    this.activities=res.data.content.deal.activityList
                }
                this.users=res.data.users
                this.user=res.data.user
                this.ownerName=this.user.name
                this.ownerSurName=this.user.surName
                for(var u in this.users){
                    if(this.users[u]._id.$oid==this.deal.cuid.$oid){
                        this.ownerName=this.users[u].name
                        this.ownerSurName=this.users[u].surName
                    }
                }
                if(res.data.permissions!==undefined){
                    this.permissions=res.data.permissions
                }else{
                    this.permissions=[]
                }
                
                if(!this.permissions.includes("can_edit_deals_closed_date") && this.isDealOpen===false){
                    this.permission=true
                }else{
                    this.permission=false
                }
                this.customFields=res.data.content.customFields
                if(res.data.content.deal.notes!==undefined){
                    this.note=res.data.content.deal.notes
                    this.note.reverse()
                }else{
                    this.note=[]
                }
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: 'Hata!',
                    text: res.data.status.desc 
                })
                 
            }
      })
    },
    removeDeal(id){
         
        axios({
            method:'POST',
            url:'/deleteDeal',
            baseURL: this.baseUrl,
            data:{
                dealId:id,
            },
            withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status===false){
                this.$router.push('/logout')
            }
            if(res.data.status.code==="0"){
                $('#deleteDeal').modal('hide')
                 
                this.$router.push('/deals')
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('WARNING'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    stageUpdate:function(event){
        this.toggleClick('stageToggle')
        this.stateId=event
        let obj={
            status:1,
            stageId:this.stateId
        }
        this.dealUpdate(obj)
    },
    dealUpdate(obj){
         
        axios({
          method:'POST',
          url:'/updateDeal',
          baseURL: this.baseUrl,
          data: {
            dealId:this.dealId,
            organizationId:this.organizationId,
            dealUpdateObj:obj
          },
          withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status.code==0){
                this.deal=res.data.content.deal
                if(res.data.content.deal.contactId!==undefined){
                    this.contact=res.data.content.deal.contactId
                    this.contactId=res.data.content.deal.contactId._id.$oid
                }
                if(res.data.content.deal.orgId!==undefined){
                    this.organization=res.data.content.deal.orgId
                    this.organizationId=res.data.content.deal.orgId._id.$oid
                    this.isHiddenAddr=false
                    this.isHiddenPhone=false
                }
                if(res.data.content.deal.status>1){
                    this.isDealOpen=false
                }else{
                    this.isDealOpen=true
                }
                this.customFields=res.data.content.customFields
                $('#dealLoseModal').modal('hide')
                this.isHiddenTitle=false
                this.isHiddenValue=false
                this.expectedDateShow=false
                this.getDeal()
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: 'Fırsat güncellendi!',
                    text: res.data.status.desc 
                })
                
                this.user=res.data.user
                if(this.user.userRoleId===2 && this.deal.status!==1){
                    this.permission=true
                }else{
                    this.permission=false
                }
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    organizationUpdate(obj){
         
        axios({
          method:'POST',
          url:'/updateOrganization',
          baseURL: this.baseUrl,
          data: {
            organizationId:this.organizationId,
            organizationUpdateObj:obj
          },
          withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status.code==0){
                this.isHiddenPhone=false
                this.isHiddenAddr=false
                this.selected=undefined
                this.getDeal()
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: this.$ml.get('COMPANY_UPDATED'),
                    text: res.data.status.desc 
                })
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    dealWon(){
        let obj={
            status:2,
            stageId:5
        }
        this.dealUpdate(obj)
    },
    dealOpenAgain(){
        let obj={
            status:1,
            stageId:1
        }
        this.dealUpdate(obj)
    },
    dealLose(){
        let array=[this.$ml.get('LAST_TO_COMPETITION'),this.$ml.get('HIGHT_PRICE'),this.$ml.get('PRODUCT_NOT_NEEDED'),this.$ml.get('OTHER')]
        let obj={
            status:3,
            stageId:5,
            lostReason:array[this.dealLoseSelect]+` : ${this.dealLoseInput}`
        }
        this.dealUpdate(obj)
    },
    updateTitle(value) {
        let obj={
            title:value,
        }
        this.dealUpdate(obj)
        setTimeout(() => {
          this.$root.$refs.completeShowPanel.getEventLogsF() 
       },100);
    },
    updateValue(event) {
        let obj={
            currency:parseInt(this.deal.currency)
        }
         if(this.deal.value!==''){
            obj["value"] = parseFloat(this.deal.value);
        }
        else if(this.deal.value==''){
            obj["value"] = 0;
        }
        this.dealUpdate(obj)
    },
    quickContact(){
        axios({
            method:'POST',
            url:'/quickFilterContact',
            baseURL: this.baseUrl,
            data: {
                search:this.search,
                organizationId:this.organizationId
            },
            withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(!res.data.status){
                this.$router.push('/logout')
            }
            if(res.data.status.code==0){
                this.items=res.data.content.contacts
                this.isHiddenContact=false
                this.isHiddenContactSelect=true
            }
        })
    },
    selectContact(event){
        let id = event.target.selectedOptions[0].id
        let obj={
            contactId:{
                $oid:id
            }
        }
        this.isHiddenContact=true
        this.isHiddenContactSelect=false
        this.dealUpdate(obj)
    },
    changeSource:function(event){
        console.log(event);
        let obj={
            source:event
        }
        this.dealUpdate(obj)
    },
    changeRate:function(event){
        console.log(event);
        let obj={
            rate:parseInt(event)
        }
        this.dealUpdate(obj)
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    organizationCard(id){
        if(id!==""){
            localStorage.orgId=id
            this.updateOrgId(id)
            window.open('/organizationCard/'+id, '_blank');
        }
    },
    contactCard(id){
        if(id!==""){
            localStorage.contactId=id
            this.updateContactId(id)
            window.open('/contactCard/'+id, '_blank');
        }
    },
    activityModalHidden(){
        let statu=false
        this.$store.dispatch('editLineStatu', statu)
        this.clearModal=true
    },
    ...mapActions([
        'updateOrgId',
        'updateContactId',
        'editRelationship',
        'updateLoading',
        'getReminders'
    ]),
    expectedDateChange(value){
        if(value!==undefined)
        {
            let date = new Date(value)
            let obj={}
            obj["expectedDate"]={
                "$date":date
            }
            this.dealUpdate(obj)
            setTimeout(() => {
                this.$root.$refs.completeShowPanel.getEventLogsF() 
            },100);
        }
    },
    relationShipData(data){
        this.deal=data
          
        if(this.deal.contactId!==undefined){
            this.contact=this.deal.contactId
            this.contactId=this.deal.contactId._id.$oid
            if(this.deal.contactId.notes!==undefined){
                this.contactNote=this.deal.contactId.notes
            }else{
                this.contactNote=[]
            }
        }
        
        if(this.deal.orgId!==undefined){
            this.organization=this.deal.orgId
            this.organizationId=this.deal.orgId._id.$oid
            if(this.deal.orgId.notes!==undefined){
                this.organizationNote=this.deal.orgId.notes
            }else{
                this.organizationNote=[]
            }
        }
    
        if(this.deal.activityList!==undefined){
            this.activities=this.deal.activityList
        }
        if(this.deal.notes!==undefined){
            this.note=this.deal.notes
        }else{
            this.note=[]
        }
    },
    updateActivity(data){
        data["edit"]=true
        this.$store.dispatch('editLine', data)
        let statu=true
        this.$store.dispatch('editLineStatu', statu)
    },
    upToggle(id){
        console.log("111111");
        console.log(id);
        if(this.windowWidth<this.maxMobilSize){
            $("#"+id).slideUp();
        }
    },
    toggleClick(id){
        console.log("2222222");
        console.log(id);
        if(this.windowWidth<this.maxMobilSize){
            $("#"+id).slideToggle();
        }
    },
    showCustomerFile(event){
        console.log(event);
        this.customerFiles=event
    },
    addNewFile(event){
            // this.fileId=event
            console.log(this.fileId);
            this.customerFiles.unshift(event) 
    },
    getDealsLog(){
        this.$root.$refs.completeShowPanel.getEventLogsF()
    },

},
mounted(){
    $(this.$refs.newActivity).on("hidden.bs.modal", this.activityModalHidden)
    $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
    $("#companyDetailTab").addClass("active")
},
created(){
    this.dealId = this.$route.params.dealId
    this.getDeal()
    this.getRemindersF()
   
},
watch: {
    updateControl: function(value) {
        if(value==true){
            this.getDeal()
            this.updateControl=false
        }
    },
    deal: {
      handler(val) {
          if(val.hasOwnProperty("source")){
        
          }else{
              console.log("source yok");
                     this.changeSource("0")
    this.changeRate("1")
          }
      },
      deep: true,
    },
    
},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    #app{
        background-color: #eceff5;
    }
    #app:before{
        display: none;
    }
</style>
<style scoped>
.headerPanel{
    box-shadow: 0px 2px 2px #b0bac59e;
    min-height: 84px;
    border-radius: 4px;
}
.Iconbtn{
    width: 28px;
    height: 28px;
    background-color: #606f8c;
    border-radius: 4px;
    text-align: center;
    padding-top: 5px;
    color:#eff3fa
}
.Iconbtn:hover{
    background-color: red;
    color: #fff;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    text-align: center;
    padding-top: 5px;
}
.new-ctk input {
  height: 28px !important;
  min-height: 28px !important;
  padding-right: 12px !important;
  color: #93959a;
}
.bg-deal{
    background: linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(134.72deg, #A8EDEA 0%, #FED6E3 98.48%);
}
.holderTitle{
    width: 60px;
    float: left;
}
.holderTitle+span{
    width: calc(100% - 60px);
    float: left;
    display: flex;
    justify-content: space-between;
}
.dealTitleInput{
    width: 300px;
}
.dealTitleInput input{
    background-color: transparent;
    border: 0;
    text-indent: 5px;
    font-size:16px;
    font-weight: 500;
    width: 300px;
}
.dealTitleInput .editTitle{
    color: #A8AAB7;
    display: none;
}
.dealTitleInput input:disabled {
    background-color: rgba(239, 243, 250, 0.5);
    border-radius: 4px;
    padding-left: 8px;
    height: 28px;
    width: 300px;
}
.dealTitleInput:hover .editTitle{
    display: inline-block;
}
.dealTitleInput:hover,.dealTitleInput.opened{
    background-color: #eff3fa;
    border-radius: 4px;
    width: 300px;
}
.dealTitleInput:hover input{
    color: #323640
}
.statuBtn{    
    height: 100%;
    border-width: 1px;
    padding: 4px 20px;
    border-radius: 4px;
    font-weight: 700;
}
.dealDate .ctk-date-time-picker:before{
    font-size: 10px;
    top:4px
}
.dealDate .ctk-date-time-picker .field .field-input{
    font-size: 11px;
}
.valueEditInput input {
    height: 100%;
    border: 1px solid #dedfe1;
    width: 50px;
    text-indent: 4px;
    font-size: 12px;
}
.valueEditCurrency .new-select {
    height: 100% !important;
    background-position-y: 3px;
    font-size: 12px;
    border-radius: 0;
    border-right: 0;
}
.valueEditBtn i{
    height: 100%; 
    align-items: center;
    display: flex;
}
.valueEditBtn .color-green:hover{
    background-color: rgb(52, 136, 49)!important;
    color: #FFF !important;
}
.valueEditBtn .color-red:hover{
    background-color:rgb(206, 30, 30)!important;
    color: #FFF !important;
}
.clickable:hover{
    cursor: pointer;
    text-decoration: underline;
}
.dealLosePopup input{
    border: 1px;
    height: 45px;
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #3767a080;
}
.deal-title {
  font-family: 'font-family-bold';
  font-size: 18px;
}
.dealBtnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 36px;
  border: 1px solid #3767a080;
  color: #3767a0;
  font-weight: normal;
  font-size: 14px;
}
.dealBtnStyle button.active {
  background-color: #3767a0!important;
  border: 1px solid #3767a0;
  color: white;
}
.dealStatus>div{
    height: 46px;
}
.dealStatus>div>div {
    border-right: 1px solid rgba(51, 51, 51, 0.10);
}
.dealStatus>div>div:last-child,.dealStatus>div>div.active {
    border-right: none;
}
.dealConfig button {
  font-family: "font-family-bold";
  font-weight: normal;
  font-size: 15px;
  height: 36px;
  border-radius: 20px;
  border: 1px solid #3767a080;
  color: #3767a0;
  background-color: transparent;
}
.dealCenter label {
  font-family: "font-family-regular";
  font-size: 14px;
}
.dealCenterUl li {
  font-size: 14px;
}
.dealCenterUl li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.dealCenterUl li a.active {
  color: #1991eb;
  background-color: #E8F4FD;
  /* font-weight: bold; */
  border-bottom: 3px solid #1991EB;
}
.dealCenterNavBar li a.active{
  background-color: #66d0ff57!important;
}
.dealCartStatus hr {
  border: 1px solid #3767a040!important;
  width: 100%!important;
}
.dealCartStatus .active {
  border: 1px solid #3767a0!important;
}
.iptal:before{
    color:red
}
.add:hover:after{
    content: "\e952";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #3767a0;
}
.hide{
    display: none
}
.hide_visible {
    visibility: hidden;
}
.show{
    visibility: visible;
}
.field:hover .icon-line-duzenle{
    visibility: visible;
}
.dealRowTabContent{
    min-height: 200px;

}
/* #organizationAll{
    height: 406px;
    overflow-y: scroll;
} */
@media (max-width: 768px) {
    .dealStatus>div {
        height:unset;
    }
    .stageSelect .selectedStage {
        height: 46px;
        line-height: 46px;
        padding-left: 15px;
        font-weight: bold;
        font-size: 12px;
        border: 0 !important;
        overflow: hidden;
        border-radius: 4px;
    }
    .stageSelect .selectedStage:before {
        content: "";
        height: 100%;
        width: 50px;
        background-color: #3767A0;
        float: right;
    }
    .stageSelect .selectedStage i{
        position: absolute;
        font-size: 30px;
        right: 15px;
        top: 7px;
    }
    .statuBtnGroup {
        width: 100%;
    }
    .statuBtnGroup>div {
        width: 50%;
    }
    .statuBtnGroup>div button {
        width: 100%;
    }
    #stageToggle>div {
        height: 46px;
        padding-left: 15px;
        line-height: 46px;
    }
    .dealCenterUl li a.active {
        color: #fff;
        font-weight: bold;
        background-color: #1991eb;
        border-bottom: 3px solid #1991EB;
    }
   
}
   .detailBorder{
        border-right: 1px solid #D1D1D7;
    }
@media (min-width: 769px){
    .fa-chevron-down{
        display: none;
    }
}
@media (max-width: 576px) {
  .dNoneMobil{
    display: none !important;
  }
}
</style>
